import { SpacerProps } from './spacer-model';
import styles from './spacer.module.scss';

export const Spacer: React.FC<SpacerProps> = ({ height }) => {
  return (
    <div
      className={`${styles.spacer} ${styles[height]}`}
      role="none"
      aria-hidden
    />
  );
};
